// Only fixed placement names travel to Play. Never include answers or health-page slugs.
export function storeUrl(placement = 'website') {
  const url = new URL(process.env.REACT_APP_GOOGLE_PLAY_URL);
  const safePlacement = ['hero', 'quiz', 'footer', 'features', 'install-bar', 'article-top', 'article-inline', 'portal', 'qr'].includes(placement) ? placement : 'website';
  url.searchParams.set('referrer', new URLSearchParams({
    utm_source: 'recalibrate_web', utm_medium: 'website',
    utm_campaign: 'app_discovery', utm_content: safePlacement,
  }).toString());
  return url.toString();
}